/* eslint-disable no-param-reassign */
import { createImmerReducer } from '@reducers/utils/createReducer';
import * as c from './types';

export interface StopsState {
  loading: boolean;
  error: any;
  success: boolean;
}

const initialState: StopsState = {
  loading: false,
  error: null,
  success: false
};

export default createImmerReducer(initialState, {
  [c.UPDATE_MULTIPLE_STOPS_CLASSIFICATION]: (draft: StopsState) => {
    draft.loading = true;
    draft.success = false;
    draft.error = null;
  },
  [c.UPDATE_MULTIPLE_STOPS_CLASSIFICATION_SUCCESS]: (draft: StopsState) => {
    draft.loading = false;
    draft.success = true;
  },

  [c.UPDATE_MULTIPLE_STOPS_CLASSIFICATION_ERROR]: (
    draft: StopsState,
    { payload }: { payload?: any }
  ) => {
    draft.loading = false;
    draft.error = payload;
  },
  [c.UPDATE_MULTIPLE_STOPS_CLASSIFICATION_RESET]: (draft: StopsState) => {
    draft.loading = false;
    draft.success = false;
    draft.error = null;
  }
});
